import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Loader2 } from "lucide-react";

// Minimal markdown-ish renderer for the ToS: headings, bold, bullets, paragraphs.
function renderMarkdown(md) {
  if (!md) return null;
  const lines = md.split("\n");
  const blocks = [];
  let listBuf = [];
  const flushList = () => {
    if (listBuf.length) {
      blocks.push(
        <ul key={`ul-${blocks.length}`} className="list-disc ml-6 my-3 space-y-1 text-gray-800">
          {listBuf.map((l, i) => <li key={i} dangerouslySetInnerHTML={{ __html: inline(l) }} />)}
        </ul>
      );
      listBuf = [];
    }
  };
  const inline = (s) => s
    .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
    .replace(/`(.+?)`/g, "<code>$1</code>");
  let paraBuf = [];
  const flushPara = () => {
    if (paraBuf.length) {
      blocks.push(
        <p key={`p-${blocks.length}`} className="my-3 leading-relaxed text-gray-800"
           dangerouslySetInnerHTML={{ __html: inline(paraBuf.join(" ")) }} />
      );
      paraBuf = [];
    }
  };
  for (const raw of lines) {
    const line = raw.trimEnd();
    if (line.startsWith("# ")) { flushList(); flushPara();
      blocks.push(<h1 key={blocks.length} className="text-4xl md:text-5xl font-black tracking-tighter mt-6">{line.slice(2)}</h1>);
    } else if (line.startsWith("## ")) { flushList(); flushPara();
      blocks.push(<h2 key={blocks.length} className="text-2xl font-black tracking-tight mt-8 mb-1">{line.slice(3)}</h2>);
    } else if (line.startsWith("- ")) { flushPara(); listBuf.push(line.slice(2));
    } else if (line.trim() === "") { flushList(); flushPara();
    } else { flushList(); paraBuf.push(line); }
  }
  flushList(); flushPara();
  return blocks;
}

export default function Terms() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/legal/terms").then(({ data }) => setData(data)); }, []);
  return (
    <div className="max-w-3xl mx-auto px-5 md:px-8 py-10" data-testid="terms-page">
      {!data ? (
        <div className="py-20 flex justify-center"><Loader2 className="w-8 h-8 animate-spin" /></div>
      ) : (
        <div className="nb-card p-8 md:p-10">
          <div className="label-eyebrow">Legal · Version {data.version}</div>
          {renderMarkdown(data.text)}
        </div>
      )}
    </div>
  );
}
